export default "__VITE_ASSET__BY8X1X_h__"